import { LineageTreePage } from './tree'

export function TreePage2() {
  return (
    <>
      <div style={{ border: '1px solid #000' }}>
        <LineageTreePage />
      </div>
    </>
  )
}
